import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'

function LinkToPlayLogVideo({ logId, backTo, backTitle }) {
	const to = `/playLogVideo/${logId}/${encodeURIComponent(backTo)}/${encodeURIComponent(
		backTitle
	)}`
	return (
		<Link to={to}>
			<Button primary size="huge" icon="play video" />
		</Link>
	)
}

LinkToPlayLogVideo.propTypes = {
	logId: PropTypes.string.isRequired,
	backTo: PropTypes.string.isRequired,
	backTitle: PropTypes.string
}

export default LinkToPlayLogVideo



// WEBPACK FOOTER //
// ./src/components/LinkToPlayLogVideo.js